import { register } from 'register-service-worker'

/**
 *
 * @param {PushManager} pushManager
 */
const subscribeUser = async pushManager => {
  const res = await pushManager.getSubscription()
  if (res === null) {
    pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey:
          'BO8ioLE7wM6Vu18E93keafSZFG9ymt0sh8jYhUO4fGkzZS-71ILMNSfAmGsHhh0WyHc7iXFlEC5PnMZWUqQIgpA'
      })
      .then(sub => {
        console.log('subscribe success: ', sub)
        // send subscription data and customer service info to server
      })
      .catch(err => alert('Notification subscribe error: ', err))
  } else {
    console.log('user is subscribed: ', res)
  }
}

register(`${process.env.BASE_URL}service-worker.js`, {
  ready(reg) {
    console.log(
      'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
    )
    if ('Notification' in self) {
      switch (self.Notification.permission) {
        case 'granted': {
          console.log('enabled notification service')
          break
        }
        case 'denied':
          console.log('Please reenable the notificaiton func!')
          break
        default:
          self.Notification.requestPermission(status => {
            console.log('notifcation permission: ', status)
          })
      }
    }
  },
  registered() {
    console.log('Service worker has been registered.')
  },
  cached() {
    console.log('Content has been cached for offline use.')
  },
  updatefound() {
    console.log('New content is downloading.')
  },
  updated() {
    console.log('New content is available; please refresh.')
  },
  offline() {
    console.log(
      'No internet connection found. App is running in offline mode.'
    )
  },
  error(error) {
    console.error('Error during service worker registration:', error)
  }
})
// }
